import $ from "jquery";

export function emitOnChange(element) {
  const e = new Event("change", { bubbles: true, cancelable: false });
  element.dispatchEvent(e);
}

export function emitOnInput(element) {
  var evt = new Event("input", { bubbles: true, cancelable: false });

  // Convert Jquery element to Vanilla JS Element
  if (element instanceof $) {
    element.each(function () {
      this.dispatchEvent(evt);
    });
    return;
  }

  // Normal JS dispatch
  if (element) {
    element.dispatchEvent(evt);
  }
}

export function emitOnClick(element) {
  var evt = new Event("click", { bubbles: true, cancelable: false });

  // Convert Jquery element to Vanilla JS Element
  if (element instanceof $) {
    element.each(function () {
      this.dispatchEvent(evt);
    });
    return;
  }

  // Normal JS dispatch
  if (element) {
    element.dispatchEvent(evt);
  }
}

export function emitGrigoraPaste(element, params) {
  var evt = new CustomEvent("grigorapaste", {
    detail: { ...(params ? params : {}) },
  });

  // Convert Jquery element to Vanilla JS Element
  if (element instanceof $) {
    element.each(function () {
      this.dispatchEvent(evt);
    });
    return;
  }

  // Normal JS dispatch
  if (element) {
    element.dispatchEvent(evt);
  }
}

export function emitOnCopy(element) {
  var evt = new Event("copy", { bubbles: true, cancelable: false });

  // Convert Jquery element to Vanilla JS Element
  if (element instanceof $) {
    element.each(function () {
      this.dispatchEvent(evt);
    });
    return;
  }

  // Normal JS dispatch
  if (element) {
    element.dispatchEvent(evt);
  }
}
